import { MiddlewareType } from './types';

export const fetchMiddleware: MiddlewareType = async (args) => {
    const { context } = args;

    if (!context.url || !context.request) {
        return Promise.reject(new Error('Request context is not properly initialized.'));
    }
    const response = await fetch(context.url, {
        ...context.request,
        credentials: 'omit',
    });
    return response.json();
};
